import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      margin: theme.spacing(0),
    },
  },
  root: {
    position: 'relative',
    paddingTop: theme.spacing(5),
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    boxSizing: 'content-box',
  },

  buttonCalculate: {
    height: '3rem',
    width: '8rem',
    fontWeight: '600',
    margin: '0 0 1rem 0',
  },

  inputBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '30ch',
    alignItems: 'center',
  },

  resultsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40vw',
  },

}));

export default useStyles;
